import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { api } from "../lib/api";

export default function NewsletterUnsubscribe() {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, ok: false, error: "" });

  useEffect(() => {
    if (!email || !token) {
      setState({ loading: false, ok: false, error: "Link non valido." });
      return;
    }
    api
      .post("/newsletter/unsubscribe", { email, token })
      .then(() => setState({ loading: false, ok: true, error: "" }))
      .catch((err) =>
        setState({
          loading: false,
          ok: false,
          error:
            err?.response?.data?.detail ||
            "Impossibile completare la disiscrizione.",
        }),
      );
  }, [email, token]);
  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-2xl mx-auto px-6 py-24 text-center">
        {state.loading ? (
          <div className="text-zinc-400">Elaborazione in corso…</div>
        ) : state.ok ? (
          <div data-testid="unsub-success">
            <CheckCircle2 size={56} className="mx-auto text-[#FBD51C] mb-4" />
            <h1 className="font-display font-black text-3xl text-white mb-3">
              Disiscrizione confermata
            </h1>
            <p className="text-zinc-400 mb-2">
              Non riceverai più email da BrickDailyDeals all&apos;indirizzo{" "}
              <span className="text-white font-bold">{email}</span>.
            </p>
            <p className="text-zinc-500 text-sm mb-8">
              Anche gli avvisi di prezzo attivi sono stati disattivati.
            </p>
            <Link
              to="/"
              data-testid="unsub-back-home"
              className="inline-flex items-center gap-2 bg-[#FBD51C] text-black font-bold px-5 py-3 rounded-lg"
            >
              Torna al sito
            </Link>
          </div>
        ) : (
          <div data-testid="unsub-error">
            <XCircle size={56} className="mx-auto text-rose-500 mb-4" />
            <h1 className="font-display font-black text-3xl text-white mb-3">
              Link non valido
            </h1>
            <p className="text-zinc-400">{state.error}</p>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
